import {
  MOVE_DATE_MIN_ISO_8601,
  MOVE_DATE_MAX_ISO_8601,
} from '../../../../constants';
import template from './move-form.html';
import './move-form.global.css';

class MoveFormController {
  $onInit() {
    this.date = {
      min: MOVE_DATE_MIN_ISO_8601,
      max: MOVE_DATE_MAX_ISO_8601,
    };
  }

  constructor($element, $scope) {
    'ngInject';
    this.el = $element;
    this.scope = $scope;
  }

  $postLink() {
    this.el
      .find('upd-datepicker-input')
      .on('input', e => this.scope.$apply(this.onDateChange(e.target.value)));
  }

  $onChanges(changes) {
    if (changes.move) {
      this.internalMove = { ...changes.move.currentValue };
    }
  }

  onDateChange(date) {
    this.internalMove = {
      ...this.internalMove,
      date,
    };
  }

  onAddressChange(property, address) {
    this.internalMove = {
      ...this.internalMove,
      [property]: address,
    };
  }

  onSubmit(move) {
    this.submitted({ $event: { move } });
  }
}

export const MoveFormComponent = {
  template,
  controller: MoveFormController,
  bindings: {
    move: '<',
    submitting: '<',
    submitted: '&',
    addressesHeaderText: '@',
    ctaDisplayText: '@',
    ctaSubmittingText: '@',
    ctaAnalyticsEvent: '@',
  },
};
